import { validBirthDate, birthDateFromBR } from '../../../helpers/ClientBirthDate';
import { useRef, useState } from 'react';
import { ProposalService } from '../../../services';
import Modal from '../../Modal';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import HelperDate from '../../../helpers/HelperDate';
import Mask from '../../../contants/Mask';
import HelperFile from '../../../helpers/helperFile';


interface IProp {
  proposal: any;
  isAccept : boolean
}
const AdditionalInformationComun = ({ proposal, isAccept }: IProp) => {
  const [errorDocs, setErrorDocs] = useState<boolean>(false);  
  const [birthdate, setBirthdate] = useState<string>(proposal.client?.birthDate
    ? proposal.client.birthDate.slice(0, 10).split('-').reverse().join('/') : '');
  const needsBirthDate = isAccept && proposal.childContractType === 'nextron'
    && proposal.client.userType !== 2;
  const [errorBirthdate, setErrorBirthdate] = useState<boolean>(false);
  const [errorDocsCnpj, setErrorDocsCnpj] = useState<boolean>(false);
  const [errorDocsCnpjContratoSocial, setErrorDocsCnpjContratoSocial] = useState<boolean>(false);
  const [checkFilesStatus, setCheckFilesStatus] = useState<boolean>(true);
  const [isLoad, setIsLoad] = useState<boolean>(false);

  function checkFile(currentBirthDate = birthdate) {
    const fileInput = document.getElementById('documentosAll') as HTMLInputElement;
    const fileInputCNPJ = document.getElementById('documentosCNPJAll') as HTMLInputElement;
    const fileInputdocumentosCNPJContratoSocialAll = document.getElementById('documentosCNPJContratoSocialAll') as HTMLInputElement;

    const file = fileInput?.files?.[0];
    const fileCNPJ = fileInputCNPJ?.files?.[0];
    const fileCNPJContratoSocial = fileInputdocumentosCNPJContratoSocialAll?.files?.[0];
    let hasError = false;

    if (!file) {
      setErrorDocs(true);
      hasError = true;
    } else {
      setErrorDocs(false);
    }
    if(needsBirthDate){
      if(!validBirthDate(birthDateFromBR(currentBirthDate ?? ''))){
        setErrorBirthdate(true);
        hasError = true;
      }else{
        setErrorBirthdate(false);
      }
    }

    if (proposal.client.userType === 2 && !fileCNPJ) {
      setErrorDocsCnpj(true);
      hasError = true;
    } else {
      setErrorDocsCnpj(false);
    }

    if (proposal.client.userType === 2 && !fileCNPJContratoSocial) {
      setErrorDocsCnpjContratoSocial(true);
      hasError = true;
    } else {
      setErrorDocsCnpjContratoSocial(false);
    }

    setCheckFilesStatus(hasError);

    return hasError;
  }
  const submitting = useRef(false);
  async function ProposalToAcceptAndFiles() {
  if (submitting.current) return;
  const fileInput = document.getElementById(
    'documentosAll'
  ) as HTMLInputElement;

  const fileInputCNPJ = document.getElementById(
    'documentosCNPJAll'
  ) as HTMLInputElement;

  const fileInputContratoSocial = document.getElementById(
    'documentosCNPJContratoSocialAll'
  ) as HTMLInputElement;

  const fileInputImoveis = document.getElementById(
    'documentosImoveisAll'
  ) as HTMLInputElement;

  if (
    needsBirthDate && !validBirthDate(birthDateFromBR(birthdate ?? ''))
  ) {
    setErrorBirthdate(true);
    return;
  }

  if (checkFile()) {
    return;
  }

  const selectedFiles = [fileInput, fileInputCNPJ, fileInputContratoSocial, fileInputImoveis]
    .flatMap(input => input?.files ? Array.from(input.files) : []);
  if (selectedFiles.some(file => file.size === 0 || file.size > 5 * 1024 * 1024 || !/\.(pdf|jpe?g|png)$/i.test(file.name))) {
    Modal.show({ title: 'Documento inválido', body: 'Envie arquivos PDF, JPG ou PNG, com conteúdo e no máximo 5 MB por arquivo.', showCancel: true, showConfirm: false });
    return;
  }
  submitting.current = true;
  setIsLoad(true);

  try {
    const [
      documentosUrls,
      cnpjUrls,
      contratoSocialUrls,
      imoveisUrls
    ] = await Promise.all([
      fileInput?.files?.length
        ? HelperFile.uploadFiles(
            fileInput,
            'proposal/DocumentClient'
          )
        : Promise.resolve([]),

      fileInputCNPJ?.files?.length
        ? HelperFile.uploadFiles(
            fileInputCNPJ,
            'proposal/DocumentClient'
          )
        : Promise.resolve([]),

      fileInputContratoSocial?.files?.length
        ? HelperFile.uploadFiles(
            fileInputContratoSocial,
            'proposal/DocumentClient'
          )
        : Promise.resolve([]),

      fileInputImoveis?.files?.length
        ? HelperFile.uploadFiles(
            fileInputImoveis,
            'proposal/DocumentClient'
          )
        : Promise.resolve([])
    ]);

    const files = [
      ...documentosUrls.map(urlBlob => ({ fileInBase64: '', urlBlob, keyType: 'DOCUMENTO', fileType: proposal.client.userType, documentType: 25 })),
      ...cnpjUrls.map(urlBlob => ({ fileInBase64: '', urlBlob, keyType: 'CNPJ', fileType: proposal.client.userType, documentType: 18 })),
      ...contratoSocialUrls.map(urlBlob => ({ fileInBase64: '', urlBlob, keyType: 'CONTRATO_SOCIAL', fileType: proposal.client.userType, documentType: 19 })),
      ...imoveisUrls.map(urlBlob => ({ fileInBase64: '', urlBlob, keyType: 'IMOVEIS', fileType: 3, documentType: 26 }))
    ];

    const payload = {
      proposalId: proposal.id,
      filesInBase64: files,
      isAccept,
      birthdate: needsBirthDate && birthdate
        ? HelperDate.convertFormatDate(
            birthdate,
            'DD/MM/YYYY',
            'YYYY-MM-DD'
          )
        : undefined
    };

    await ProposalService.SaveAdditionalInformationFiles(payload);

    Modal.show({
      title: 'Aceite Proposta',
      body: (
        <>
          <p>Salvo com sucesso!</p>
        </>
      ),
      showCancel: false,
      showConfirm: true
    });

    window.location.reload();
  } catch (error: any) {
    submitting.current = false;
    setIsLoad(false);

    Modal.show({
      title: 'Erro ao salvar',
      body: Modal.getErrorMessage(error, {
        filesInBase64: null,
        proposalId: proposal.id,
        fileType: proposal.client.userType
      }),
      showCancel: true,
      showConfirm: false,
      onCancelText: 'Fechar'
    });
  }
}

  return (
    <>
      {
        isLoad &&
        <LoadingSpinner text='Processando Arquivo...' />
      }
      <div className="form-group" style={{ marginBottom: 10 }}>
        <label htmlFor="documentos"> Documento {(proposal.client.userType === 2) ? "do representante!" : ""} (CNH) (*)</label>
        <input
          type="file"
          id="documentosAll"
          name="documentosAll"
          onChange={() => checkFile()}
          accept=".pdf,.jpg,.jpeg,.png"
          className={'form-control'}
          multiple
        />
        {errorDocs && <span className="error-message" style={{ color: '#f52020', fontSize: 10 }}>Selecione o arquivo do CNH ou RG em um dos formatos: .pdf,.jpg,.jpeg,.png</span>}
      </div>
      {
        needsBirthDate &&
        <div className="form-group" style={{ marginBottom: 10 }}>
          <label htmlFor="birthdate"> Data de Nascimento {(proposal.client.userType === 2) ? "do representante!" : ""} (Exemplo: 01/01/1990 ) (*)</label>
          <input
            type="text"
            id="birthdate"
            name="birthdate"
            maxLength={10}
            style={{maxWidth: 139}}
            placeholder='DD/MM/AAAA'
            value={Mask.date(birthdate)?? ''}
            onChange={(e) => {
              setBirthdate(e.target.value);
              checkFile(e.target.value);
            }}
            className={'form-control'}
          />
          {errorBirthdate && <span className="error-message" style={{ color: '#f52020', fontSize: 10 }}>Informe a data de nascimento!</span>}
        </div>
      }
      {
        (proposal.client.userType === 2) &&
        <>
          <div className="form-group" style={{ marginBottom: 10 }}>
            <label htmlFor="documentos"> Cartão CNPJ <span style={{ fontSize: 10 }}>(COMPROVANTE DE INSCRIÇÃO E DE SITUAÇÃO CADASTRAL)</span> (*)</label>
            <input
              type="file"
              id="documentosCNPJAll"
              onChange={() => checkFile()}
              name="documentosCNPJAll"
              accept=".pdf,.jpg,.jpeg,.png"
              className={'form-control'}
              multiple
            />
            {errorDocsCnpj && <span className="error-message" style={{ color: '#f52020', fontSize: 10 }}>Selecione o arquivo do Cartão CNPJ em um dos formatos: .pdf,.jpg,.jpeg,.png</span>}
          </div>

          <div className="form-group" style={{ marginBottom: 10 }}>
            <label htmlFor="documentosCNPJContratoSocialAll"> Contrato Social (*)</label>
            <input
              type="file"
              id="documentosCNPJContratoSocialAll"
              onChange={() => checkFile()}
              name="documentosCNPJContratoSocialAll"
              accept=".pdf,.jpg,.jpeg,.png"
              className={'form-control'}
              multiple
            />
            {errorDocsCnpjContratoSocial && <span className="error-message" style={{ color: '#f52020', fontSize: 10 }}>Selecione o arquivo do Contrato Social em um dos formatos: .pdf,.jpg,.jpeg,.png</span>}
          </div>
        </>
      }
      {
         ((proposal?.proposalType?.name ?? '') === 'Solar Direct') &&
          <div className="form-group" style={{ marginBottom: 10 }}>
            <label htmlFor="documentos" style={{marginBottom:2}}> Propriedade do imóvel (*)</label>
            <span style={{fontSize:12, color:'#9b9898', display:'block', fontWeight:'normal'}}>(tipo: IPTU)</span>
            <input
              type="file"
              id="documentosImoveisAll"
              name="documentosImoveisAll"
              onChange={() => checkFile()}
              accept=".pdf,.jpg,.jpeg,.png"
              className={'form-control'}
              multiple
            />
            {errorDocs && <span className="error-message" style={{ color: '#f52020', fontSize: 10 }}>Selecione o arquivo do Propriedade do imóvel em um dos formatos: .pdf,.jpg,.jpeg,.png</span>}
          </div>

      }
      <span className="d-block" style={{ color: '#615f5fff', fontSize: 11 }}>* Aceita apenas documentos dos tipos: .pdf, .jpg, .jpeg, .png com máximo de 5mb</span>
      <button type="button" disabled={checkFilesStatus || isLoad} className="btn btn-success btn-lg waves-effect waves-light" onClick={ProposalToAcceptAndFiles} style={{ width: '100%', marginTop: 10 }}>
        {(isAccept)? 'Aceitar e salvar': 'Salvar Documentos'}
        </button>
    </>
  )
};

export default AdditionalInformationComun;
